import { createRouter, createWebHistory } from 'vue-router'
import store from '@/member/stores/store'

const VerifyCode = () => import(/* webpackChunkName: "js/chunks/member_verify_code" */ '@/member/views/auth/VerifyCode')
const Login = () => import(/* webpackChunkName: "js/chunks/member_login" */ '@/member/views/auth/Login')
const ForgotPassword = () =>
  import(/* webpackChunkName: "js/chunks/forgot_password" */ '@/member/views/auth/ForgotPassword')
const AccountLockout = () =>
  import(/* webpackChunkName: "js/chunks/account_lockout" */ '@/member/views/auth/AccountLockout')
const ForgotPasswordComplete = () =>
  import(/* webpackChunkName: "js/chunks/forgot_password_complete" */ '@/member/views/auth/ForgotPasswordComplete')
const ResetPassword = () =>
  import(/* webpackChunkName: "js/chunks/reset_password" */ '@/member/views/auth/ResetPassword')
const ResetPasswordComplete = () =>
  import(/* webpackChunkName: "js/chunks/reset_password_complete" */ '@/member/views/auth/ResetPasswordComplete')
const Organizations = () =>
  import(/* webpackChunkName: "js/chunks/fcs/organizations" */ '@/member/views/fcs/Organizations')
const OrganizationDetail = () =>
  import(/* webpackChunkName: "js/chunks/fcs/OrganizationDetail" */ '@/member/views/fcs/OrganizationDetail')
const YieldTables = () => import(/* webpackChunkName: "js/chunks/fcs/YieldTables" */ '@/member/views/fcs/YieldTables')
const YieldTableDetail = () =>
  import(/* webpackChunkName: "js/chunks/fcs/YieldTableDetail" */ '@/member/views/fcs/YieldTableDetail')
const ForestInformationList = () =>
  import(/* webpackChunkName: "js/chunks/fcs/ForestInformationList" */ '@/member/views/fcs/ForestInformationList')
const Members = () => import(/* webpackChunkName: "js/chunks/fcs/Members" */ '@/member/views/fcs/Members')
const FcsSimulationResults = () =>
  import(/* webpackChunkName: "js/chunks/fcs/simulation-results" */ '@/member/views/fcs/SimulationResults')
const FcsApplicationList = () =>
  import(/* webpackChunkName: "js/chunks/fcs/application-list" */ '@/member/views/fcs/ApplicationList')
const FcsApplicationDetail = () =>
  import(/* webpackChunkName: "js/chunks/fcs/application-detail" */ '@/member/views/fcs/ApplicationDetail')
const FcsManageImport = () =>
  import(/* webpackChunkName: "js/chunks/fcs/manage/import" */ '@/member/views/fcs/manage/Import')
const FcsManageSimulations = () =>
  import(/* webpackChunkName: "js/chunks/fcs/manage/simulations" */ '@/member/views/fcs/manage/Simulations')
const FcsManageSimulationsCreate = () =>
  import(/* webpackChunkName: "js/chunks/fcs/manage/simulations" */ '@/member/views/fcs/manage/SimulationCreate')
const FcsManageSimulationsEdit = () =>
  import(/* webpackChunkName: "js/chunks/fcs/manage/simulations" */ '@/member/views/fcs/manage/SimulationEdit')
const ProjectList = () => import(/* webpackChunkName: "js/chunks/fcs/ProjectList" */ '@/member/views/fcs/ProjectList')
const ProjectDetail = () =>
  import(/* webpackChunkName: "js/chunks/fcs/ProjectDetail" */ '@/member/views/fcs/ProjectDetail')
const Simulations = () => import(/* webpackChunkName: "js/chunks/fcs/Simulations" */ '@/member/views/fcs/Simulations')
const SimulationDetail = () =>
  import(/* webpackChunkName: "js/chunks/fcs/simulation-detail" */ '@/member/views/fcs/SimulationDetail')
const MonitoringSetting = () =>
  import(/* webpackChunkName: "js/chunks/fcs/monitoring-setting" */ '@/member/views/fcs/MonitoringSetting')
const RegisteredProjectDetail = () =>
  import(/* webpackChunkName: "js/chunks/fcs/registered-project-detail" */ '@/member/views/fcs/RegisteredProjectDetail')
const OtherDocuments = () =>
  import(/* webpackChunkName: "js/chunks/fcs/other-documents" */ '@/member/views/fcs/OtherDocuments')
const ForestManagementPlanCertification = () =>
  import(
    /* webpackChunkName: "js/chunks/fcs/forest-management-plan-certification" */ '@/member/views/fcs/ForestManagementPlanCertification'
  )
const ProtectionImplementationRecord = () =>
  import(
    /* webpackChunkName: "js/chunks/fcs/protection-implementation-record" */ '@/member/views/fcs/ProtectionImplementationRecord'
  )
const ForestManagementPlanFull = () =>
  import(
    /* webpackChunkName: "js/chunks/fcs/forest-management-plan-full" */ '@/member/views/fcs/ForestManagementPlanFull'
  )
const ProjectPlanSubmissionDocuments = () =>
  import(
    /* webpackChunkName: "js/chunks/fcs/project-plan-submission-documents" */ '@/member/views/fcs/ProjectPlanSubmissionDocuments'
  )
const MonitoringReportDocuments = () =>
  import(
    /* webpackChunkName: "js/chunks/fcs/monitoring-report-documents" */ '@/member/views/fcs/MonitoringReportDocuments'
  )
const PlanChangeDocuments = () =>
  import(/* webpackChunkName: "js/chunks/fcs/plan-change-documents" */ '@/member/views/fcs/PlanChangeDocuments')
const ContractDocuments = () =>
  import(/* webpackChunkName: "js/chunks/fcs/contract-documents" */ '@/member/views/fcs/ContractDocuments')
const PositionEvidence = () =>
  import(/* webpackChunkName: "js/chunks/fcs/position-evidence" */ '@/member/views/fcs/PositionEvidence')
const LoggingNotificationCopy = () =>
  import(/* webpackChunkName: "js/chunks/fcs/logging-notification-copy" */ '@/member/views/fcs/LoggingNotificationCopy')
const SustainabilityConfirmation = () =>
  import(
    /* webpackChunkName: "js/chunks/fcs/sustainability-confirmation" */ '@/member/views/fcs/SustainabilityConfirmation'
  )
const AreaEvidence = () =>
  import(/* webpackChunkName: "js/chunks/fcs/area-evidence" */ '@/member/views/fcs/AreaEvidence')
const MeetingRecord = () =>
  import(/* webpackChunkName: "js/chunks/fcs/meeting-record" */ '@/member/views/fcs/MeetingRecord')
const ForestBook = () => import(/* webpackChunkName: "js/chunks/fcs/forest-book" */ '@/member/views/fcs/ForestBook')
const TransactionSlips = () =>
  import(/* webpackChunkName: "js/chunks/fcs/transaction-slips" */ '@/member/views/fcs/TransactionSlips')

const ProjectYieldTables = () =>
  import(/* webpackChunkName: "js/chunks/fcs/project/yield-tables" */ '@/member/views/fcs/ProjectYieldTables')
const MonitoringPlotMap = () =>
  import(/* webpackChunkName: "js/chunks/fcs/monitoring-plot-map" */ '@/member/views/fcs/MonitoringPlotMap')

const router = createRouter({
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  history: createWebHistory('/'),
  base: '/',
  routes: [
    {
      path: '/login',
      component: Login,
      name: 'auth.login',
      meta: {
        layout: 'empty',
        title: 'login.title_page',
        requireAuth: false,
        requireCode: false,
        redirectToTopIfAuthenticated: true,
      },
    },
    {
      path: '/forgot-password',
      component: ForgotPassword,
      name: 'auth.forgot_password',
      meta: {
        layout: 'empty',
        requireAuth: false,
        requireCode: false,
        redirectToTopIfAuthenticated: true,
      },
    },
    {
      path: '/forgot-password-complete',
      component: ForgotPasswordComplete,
      name: 'auth.forgot_password_complete',
      meta: {
        layout: 'empty',
        requireAuth: false,
        requireCode: false,
        redirectToTopIfAuthenticated: true,
      },
    },
    {
      path: '/reset-password',
      component: ResetPassword,
      name: 'auth.reset_password',
      meta: {
        layout: 'empty',
        requireAuth: false,
        requireCode: false,
        redirectToTopIfAuthenticated: true,
      },
    },
    {
      path: '/reset-password-complete',
      component: ResetPasswordComplete,
      name: 'auth.reset_password_complete',
      meta: {
        layout: 'empty',
        requireAuth: false,
        requireCode: false,
        redirectToTopIfAuthenticated: true,
      },
    },
    {
      path: '/verify-code',
      component: VerifyCode,
      name: 'auth.verify_code',
      meta: {
        layout: 'empty',
        requireAuth: true,
        requireCode: false,
        redirectToTopIfAuthenticated: true,
      },
    },
    {
      path: '/account-lockout',
      component: AccountLockout,
      name: 'auth.account_lockout',
      meta: {
        layout: 'empty',
        requireAuth: true,
        requireCode: false,
      },
    },
    {
      path: '/fcs/organizations',
      component: Organizations,
      name: 'fcs.organizations',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/organization/:id',
      component: OrganizationDetail,
      name: 'fcs.organization.detail',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/yield_tables',
      component: YieldTables,
      name: 'fcs.yield_tables',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/yield_tables/:id',
      component: YieldTableDetail,
      name: 'fcs.yield_tables.detail',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/members',
      component: Members,
      name: 'fcs.members.list',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/forest_information_list',
      component: ForestInformationList,
      name: 'fcs.forest_information_list',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/simulation_results',
      component: FcsSimulationResults,
      name: 'fcs.simulation_results',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/application_list',
      component: FcsApplicationList,
      name: 'fcs.application_list',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/application_list/:id',
      component: FcsApplicationDetail,
      name: 'fcs.application_detail',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/manage/import',
      component: FcsManageImport,
      name: 'fcs.manage_import',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/manage/simulations',
      component: FcsManageSimulations,
      name: 'fcs.manage_simulations',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/manage/simulations/create',
      component: FcsManageSimulationsCreate,
      name: 'fcs.manage_simulations.create',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/manage/simulations/edit/:id/:name',
      component: FcsManageSimulationsEdit,
      name: 'fcs.manage_simulations.edit',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project_list',
      component: ProjectList,
      name: 'fcs.projects',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:id/:registered_flg?',
      component: ProjectDetail,
      name: 'fcs.project.detail',
      // registered_flgはデフォルトでfalseにする
      props: route => ({
        ...route.params,
        registered_flg: route.params.registered_flg === undefined ? false : route.params.registered_flg,
      }),
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:id/simulations',
      component: Simulations,
      name: 'fcs.project.simulations',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:projectId/simulation/:simulationId',
      component: SimulationDetail,
      name: 'fcs.project.simulation.detail',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:projectId/simulation/:simulationId/monitoring',
      component: MonitoringSetting,
      name: 'fcs.project.simulation.monitoring',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/registered-project/:id',
      component: RegisteredProjectDetail,
      name: 'fcs.registered_project.detail',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:projectId/other-documents/:fiscalYear',
      component: OtherDocuments,
      name: 'fcs.project.other_documents',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:projectId/yield-table',
      component: ProjectYieldTables,
      name: 'fcs.project.yield_table',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:projectId/forest-management-plan-certification/:fiscalYear',
      component: ForestManagementPlanCertification,
      name: 'fcs.project.forest_management_plan_certification',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:projectId/project-plan-submission-documents/:fiscalYear',
      component: ProjectPlanSubmissionDocuments,
      name: 'fcs.project.project_plan_submission_documents',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:projectId/forest-management-plan-full/:fiscalYear',
      component: ForestManagementPlanFull,
      name: 'fcs.project.forest_management_plan_full',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:projectId/forest-management-plan-full/:fiscalYear',
      component: ForestManagementPlanFull,
      name: 'fcs.project.forest_management_plan_full',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    // モニタリング報告書
    {
      path: '/fcs/project/:projectId/monitoring_report_documents/:fiscalYear',
      component: MonitoringReportDocuments,
      name: 'fcs.project.monitoring_report_documents',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    // 計画変更通知書
    {
      path: '/fcs/project/:projectId/plan-change-documents/:fiscalYear',
      component: PlanChangeDocuments,
      name: 'fcs.project.plan_change_documents',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:projectId/contract-documents/:fiscalYear',
      component: ContractDocuments,
      name: 'fcs.project.contract_documents',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:projectId/position-evidence/:fiscalYear',
      component: PositionEvidence,
      name: 'fcs.project.position_evidence',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:projectId/logging-notification-copy/:fiscalYear',
      component: LoggingNotificationCopy,
      name: 'fcs.project.logging_notification_copy',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:projectId/sustainability-confirmation/:fiscalYear',
      component: SustainabilityConfirmation,
      name: 'fcs.project.sustainability_confirmation',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:projectId/area-evidence/:fiscalYear',
      component: AreaEvidence,
      name: 'fcs.project.area_evidence',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:projectId/protection-implementation-record/:fiscalYear',
      component: ProtectionImplementationRecord,
      name: 'fcs.project.protection_implementation_record',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:projectId/meeting-record/:fiscalYear',
      component: MeetingRecord,
      name: 'fcs.project.meeting_record',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:projectId/forest-book/:fiscalYear',
      component: ForestBook,
      name: 'fcs.project.forest_book',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:projectId/transaction-slips/:fiscalYear',
      component: TransactionSlips,
      name: 'fcs.project.transaction_slips',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:projectId/monitoring-plot-map',
      component: MonitoringPlotMap,
      name: 'fcs.project.monitoring_plot_map',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
    {
      path: '/fcs/project/:projectId/plan-change-documents/:fiscalYear',
      component: PlanChangeDocuments,
      name: 'fcs.project.plan_change_documents',
      meta: {
        layout: 'normal',
        requireAuth: true,
        requireCode: true,
      },
    },
  ],
  linkActiveClass: 'active',
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireAuth) && to.matched.some(record => record.meta.requireCode)) {
    // if logged in and verified code
    if (store.getters.isSetToken && store.getters.isVerifyCode) {
      return next()
    }
    return next({ name: 'auth.login' })
  } else if (
    to.matched.some(record => record.meta.requireAuth) &&
    !to.matched.some(record => record.meta.requireCode)
  ) {
    // check if logged in and do not verify code
    if (!store.getters.isSetToken) {
      return next({ name: 'auth.login' })
    }
  } else if (
    !to.matched.some(record => record.meta.requireAuth) &&
    to.matched.some(record => record.meta.redirectToTopIfAuthenticated)
  ) {
    // 認証不要ページでログイン状態の場合はログイン後トップへ遷移
    if (store.getters.isSetToken && store.getters.isVerifyCode) {
      return next({ name: 'fcs.members.list' })
    } else {
      // ログイン後に本来アクセスしようとしていたページにアクセスできるようURLをLocal Storageに記録する
      localStorage.setItem('ACCESSED_URL', document.URL)
    }
  }
  next()
})

export default router
